// Sign-out confirm dialog — consumer is calmer than admin (protects an
// in-progress framework).
//
// Per tenant-shell-strings.md §"Sign-out flow".

import { useEffect } from 'react';
import { Button } from '@gc-coach/design-system';
import { useI18n } from '../i18n/index.js';
import styles from './SignOutConfirm.module.css';

export interface SignOutConfirmProps {
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}

export function SignOutConfirm({ onCancel, onConfirm }: SignOutConfirmProps) {
  const { t } = useI18n();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className={styles.backdrop} role="presentation" onClick={onCancel}>
      <div
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="signout-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="signout-title" className={styles.title}>
          {t('shell.signOutTitle')}
        </h2>
        <p className={styles.body}>{t('shell.signOutBody')}</p>
        <div className={styles.actions}>
          <Button kind="ghost" onClick={onCancel}>
            {t('shell.signOutCancel')}
          </Button>
          <Button kind="danger" onClick={() => void onConfirm()}>
            {t('shell.signOutConfirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
